const couponActions = {
    GET_COUPON_BY_MOBILENUMBER: 'GET_COUPON_BY_MOBILENUMBER',
    SET_COUPON_BY_MOBILENUMBER: 'SET_COUPON_BY_MOBILENUMBER',
    SET_AVAILABLE_COUPON_LIST: 'SET_AVAILABLE_COUPON_LIST',
    GET_COUPON_SHOW:'GET_COUPON_SHOW',
    SET_COUPON_SHOW:' SET_COUPON_SHOW',
};

export default couponActions;